/**
 * SYNC STATUS v2.0 - ULTRA OPTIMIZED
 * ✅ React.memo para componentes
 * ✅ useMemo para clases CSS
 * ✅ Componentes separados optimizados
 */
import { useMemo, memo } from 'react';
import { useFirebase } from '../context/FirebaseContext';

const SyncStatus = memo(function SyncStatus() {
  const { isSyncing, syncEnabled, household } = useFirebase();

  const positionClasses = useMemo(() => 
    "fixed top-5 right-32 z-50 pointer-events-none transition-all duration-300"
  , []);

  if (!syncEnabled || !household) {
    return <OfflineStatus positionClasses={positionClasses} />;
  }

  if (isSyncing) {
    return <SyncingStatus positionClasses={positionClasses} />;
  }

  return <SyncedStatus positionClasses={positionClasses} />;
});

// ✅ COMPONENTES MEMOIZADOS

const OfflineStatus = memo(function OfflineStatus({ positionClasses }) {
  return (
    <div className={positionClasses}>
      <span className="bg-gray-800/90 backdrop-blur text-gray-400 text-[10px] font-medium px-2.5 py-1 rounded-full border border-gray-700/50 flex items-center gap-1.5 shadow-lg">
        ☁️ <span className="hidden sm:inline">Offline</span>
      </span>
    </div>
  );
});

const SyncingStatus = memo(function SyncingStatus({ positionClasses }) {
  return (
    <div className={positionClasses}>
      <span className="bg-blue-900/90 backdrop-blur text-blue-200 text-[10px] font-medium px-3 py-1 rounded-full border border-blue-700/50 flex items-center gap-2 shadow-lg animate-pulse">
        <SpinnerIcon />
        Sync...
      </span>
    </div>
  );
});

const SyncedStatus = memo(function SyncedStatus({ positionClasses }) {
  return (
    <div className={positionClasses}>
      <span className="bg-green-900/80 backdrop-blur text-green-200 text-[10px] font-medium px-2.5 py-1 rounded-full border border-green-700/50 flex items-center gap-1.5 shadow-sm transition-opacity duration-500 opacity-60 hover:opacity-100">
        ✓ <span className="hidden sm:inline">Al día</span>
      </span>
    </div>
  );
});

const SpinnerIcon = memo(function SpinnerIcon() {
  return (
    <svg 
      className="animate-spin h-3 w-3 text-blue-300" 
      xmlns="http://www.w3.org/2000/svg" 
      fill="none" 
      viewBox="0 0 24 24"
    >
      <circle 
        className="opacity-25" 
        cx="12" 
        cy="12" 
        r="10" 
        stroke="currentColor" 
        strokeWidth="4"
      />
      <path 
        className="opacity-75" 
        fill="currentColor" 
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
});

export default SyncStatus;
